import Collection from "../../data-structures/collection";
import Office from "./office";


export default class OfficesCollection extends Collection<Office>{

    constructor(models:Office[]) {
        super(models);
    }

    static initFromJson(data: any): OfficesCollection{

        const models: Office[] = []

        _.map(data, (record: JSONObject)=>{
            models.push(new Office(record))
        })

        return new OfficesCollection(models)
    }

    getOffice(officeId: ID){
        return _.find(this.models, (office)=>office.id === officeId)
    }

    sort() {
        this.models = _.orderBy(this.models, (model:Office) => model.sortPosition)
    }

    getExistingOffices():OfficesCollection {

        const existingOffices = new OfficesCollection(_.filter(this.models, (location: Office)=>!location.isDeleted))
        existingOffices.sort()

        return existingOffices
    }

    get notDeleted() : Office[] {
        return _.filter(this.models, (office:Office)=>{
            return !office.isDeleted
        })
    }

    toOptions():Option[] {

        return _.map(this.notDeleted, (office:Office)=>{
            return office.toOption()
        }) as Option[]

    }

}
